export default "__VITE_ASSET__BTsfscb9__"